var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCerrarSymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "color"
    },
    cx: 256,
    cy: 256,
    rx: 256,
    ry: 255.832
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 77.26 32)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.98,
    y: -427.615,
    style: {
      fill: "color"
    },
    width: 55.992,
    height: 285.672
  }), /*#__PURE__*/React.createElement("rect", {
    x: -110.828,
    y: -312.815,
    style: {
      fill: "color"
    },
    width: 285.672,
    height: 55.992
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrarSymbol);
export default __webpack_public_path__ + "static/media/cerrar-symbol.787243c1.svg";
export { ForwardRef as ReactComponent };